<template>
  <f7-page name="upcoming" class="newss">
    <f7-navbar title="News Details" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>


      <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
              <f7-block-title v-if="news.id">{{ news.title }}</f7-block-title>

    <f7-block v-if="news.id">

        <div :style="'background-size: cover; height: 40vw; color: #FFF; font-weight: bold; background-image:url('+ $root.siteURL + news.photo.replace('public', 'storage') + ')'" class="card-header align-items-flex-end"></div>

        <p class="date">{{ news.created_at }} - <strong>{{ news.event.name }}</strong></p>

        <div class="news-content" v-html="news.content"></div>

    </f7-block>
        </div>
      </f7-row>

    



  </f7-page>
</template>
<script>
export default {
    data() {
      return {
        news: {}
      }
    },
    mounted: function() {
      this.news = JSON.parse( sessionStorage.getItem('currentNews') )
    }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
</style>
